import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import { useRef, useState } from 'react'
import { DataSaverOn, PostAdd } from '@mui/icons-material'
import { ListItemIcon } from '@mui/material'
 
const options = [
  { label: 'Upload A Document', icon: 'postAdd', path: '/upload' },
  { label: 'Upload A Pulse', icon: 'dataSaverOn', path: '/uploadPulse' }
]

export default function DashboardButtonGroup ({ navigate }) {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)
  const [selectedIndex, setSelectedIndex] = useState(1)

  const handleClick = () => {
    navigate(options[selectedIndex].path)
  }

  const handleMenuItemClick = (_event, index) => {
    setSelectedIndex(index)
    setOpen(false)
    navigate(options[index].path)
  }

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  return (
    <>
      <ButtonGroup
        variant='contained'
        ref={anchorRef}
        color='success'
        aria-label='Button group with a nested menu'
      >
        <Button
          startIcon={
            options[selectedIndex].icon === 'postAdd' ? (
              <PostAdd />
            ) : (
              <DataSaverOn />
            )
          }
          onClick={handleClick}
        >
          {options[selectedIndex].label}
        </Button>
        <Button
          size='small'
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup='menu'
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 2 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id='split-button-menu' autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option.label}
                      disabled={index === 2}
                      selected={index === selectedIndex}
                      onClick={event => handleMenuItemClick(event, index)}
                    >
                      <ListItemIcon>
                        {option.icon === 'postAdd' ? (
                          <PostAdd fontSize='small' />
                        ) : (
                          <DataSaverOn fontSize='small' />
                        )}
                      </ListItemIcon>
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}
